$(document).ready(function () {


    //
    $(window).on('resize ready orientationchange load', $.debounce(105, function () {

        $('.map').height($('.mapside').outerHeight());

        footer = $('.slides > li.footer');

        window_h = $(window).height();

        if (footer.length > 0) {

            if (footer.offset().top < (window_h - footer.height())) {
                footer.prev('li').css('min-height', (window_h - footer.height()));
            }
            else {
                footer.prev('li').css('min-height', 428);
            }
        }

    }));

    //
    if ($('li.header .slide-inner > ul').length == 1) {
        ul = $('li.header .slide-inner > ul');

        ul.find('li').removeClass('active');

        path = location.pathname;
        path = path.split('/');
        path = path[1];

        ul.find('a[href=' + path + ']').closest('li').addClass('active');
    }

    //
    $(window).on('resize ready orientationchange load', $.debounce(105, function () {

        window_h = $(window).height();

        //Make element the height of the current viewport (excluding header)
        slide_h = window_h;
        $('.window-height').css('height', slide_h).css('min-height', slide_h);

        //Center .slide-inner vertically within its parent slide
        $('.center-within-slide').each(function () {

            slide = $(this).closest('li');
            slide_inner = $(this).find('.slide-inner');

            parent_h = slide.height();

            element_h = slide_inner.outerHeight();

            element_top = (parent_h - element_h) / 2;

            slide_inner.css('top', element_top);
        });

        //
        if ($('ul.products').length > 0) {
            products_h = $('ul.products').height();
            $('aside').height(products_h);
        }

    }));

    $(window).on('scroll', function () {

        if ($('header').isOffScreen()) {
            $('header > nav').addClass('sticky');
        }
        else {
            $('header > nav').removeClass('sticky');
        }

    });


    $(window).on('resize ready orientationchange load scroll', function () {

        $('.slides > li').each(function () {

            if ($(this).hitScreenTop()) {
                if ($(this).hasClass('light-nav')) {
                    $('body').addClass('light-nav');
                }
                else {
                    $('body').removeClass('light-nav');
                }

            }

        });

    });


});

function scrollToTop() {
    $('html, body').animate({
        scrollTop: 0
    }, 250);
}


$.fn.hitScreenTop = function () {

    target = this;

    scroll_pos = $(window).scrollTop() + $('header').outerHeight();

    target_pos = target.offset().top;

    if (scroll_pos >= target_pos) {
        return true;
    }
    else {
        return false;
    }

};

$.fn.isOffScreen = function () {

    target = this;

    window_h = $(window).height();

    scroll_pos = $(window).scrollTop();

    target_pos = target.offset().top + target.outerHeight();

    if (scroll_pos < target_pos) {
        return false;
    }
    else {
        return true;
    }

};

$.fn.isOnScreen = function () {

    target = this;

    window_h = $(window).height();

    scroll_pos = $(window).scrollTop();

    target_pos = target.offset().top;

    if (scroll_pos >= target_pos - window_h) {
        return true;
    }
    else {
        return false;
    }

};
